export default __webpack_public_path__ + "media/icons/close-xmark-9c3238f6.svg";